import { render, staticRenderFns } from "./Elastic.vue?vue&type=template&id=dcc3094a"
import script from "./Elastic.vue?vue&type=script&lang=js"
export * from "./Elastic.vue?vue&type=script&lang=js"
import style0 from "./Elastic.vue?vue&type=style&index=0&id=dcc3094a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports